import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonWhyChoose = () => (
  <section className="nv-section nv-why" id="why">
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Why us</p>
        <h2 className="nv-title">Why Choose Neon Verse Studio</h2>
        <div className="nv-why__lines">
          {NEONVERSE.whyLines.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>
        <p className="nv-why__close">
          At Neon Verse Studio, we don&apos;t simply produce songs.
          <br />
          <strong>We create soundtracks to life&apos;s most meaningful moments.</strong>
        </p>
      </motion.div>
    </div>
  </section>
);

export default NeonWhyChoose;
